import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getJobDetailsApi = createApi('api/admin/jobInputs', 'GET');

const GetJobDetails = createSlice({
  name: 'GetJobDetails',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getJobDetailsApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJobDetailsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getJobDetailsApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetJobDetails.reducer;